
















































































import AirportTerminal from '@/store/entities/flight/airportTerminal';
import { Component, Vue } from 'vue-property-decorator';
import AddTerminal from './modals/addTerminal.vue';

@Component({
  components: { AddTerminal },
})
export default class Terminals extends Vue {
  search: string = '';
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  airportTerminals: AirportTerminal[] = [];

  created() {
    this.getAirportTerminals();
    (this.headers = [
      { text: 'Havaalanı Terminalleri', value: 'terminal' },
      { text: 'Havaalanı Kimliği', value: 'airportId' },
      { text: 'İşlemler', value: 'transactions' },
    ]),
      (this.mockData = [
        {
          terminal: 'xx',
          id: 'AYT',
        },
      ]);

    this.breadcrumbsItems = [
      { text: 'Ana Sayfa', disabled: false, href: '/#/main/home' },
      { text: 'Tanımlamalar', disabled: true },
      { text: 'Havaalanı Terminalleri', disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getAirportTerminals() {
    await this.$store.dispatch({
      type: 'airportTerminal/getAirportTerminals',
    });

    this.airportTerminals = this.$store.state.airportTerminal.list;
  }

  editAirportTerminal(item) {
    this.$store.state.airportTerminal.editAirportTerminal = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.airportTerminal.editAirportTerminal = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getAirportTerminals();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
